<template>
	<div>
		<HeadIndex></HeadIndex>
		<div ref="height_top">
			<el-row>
				<el-col :span="12" :offset="6">
					<div class="policy-wrap">
						<!-- 政策标题 -->
						<h1 class="policy-title">脱手网隐私政策</h1>
						<!-- 发布与生效日期 -->
						<div class="policy-date">
							发布日期：2025年9月2日<br><br>
							生效日期：2025年9月2日
						</div>
						<!-- 政策引言 -->
						<p class="policy-intro">
							欢迎您使用脱手网（包括PC端网站及移动应用程序）！我们深知个人信息对您的重要性，并庄严承诺将按法律法规要求，采取相应安全保护措施，全力保护您的个人信息安全可控。
						</p>
						<p class="policy-intro">
							在您使用脱手网的服务前，<span class="highlight">请您务必仔细阅读、充分理解本政策各条款内容，特别是那些以加粗、下划线等形式显著标识的条款</span>（涉及我们如何收集和使用您的个人信息、我们如何共享、转让、公开披露您的个人信息、您的权利等）。一旦您开始使用或继续使用我们的服务，即表示您已同意我们按照本政策处理您的个人信息。
						</p>
						<!-- 一、我们如何收集和使用您的信息 -->
						<h2 class="chapter-title">一、我们如何收集和使用您的信息</h2>
						<h3 class="subchapter-title">（一）我们如何收集您的信息</h3>
						<p>我们收集信息是为了向您提供更优质的服务，并遵循“合法、正当、必要”的原则。具体方式包括：</p>
						<p> <span class="highlight">您主动提供的信息：</span></p>
						<ol class="policy-list">
							<li><span class="highlight">1.账号信息：</span>当您注册脱手网账号时，我们会收集您的<span class="highlight">手机号码、用户名、密码，</span>用于创建您的专属账户。</li>
							<li><span class="highlight">2.企业信息：</span>若您申请成为认证用户（如供应商），我们可能会收集您的<span class="highlight">企业名称、联系人姓名、联系电话、营业执照信息</span>（如适用），以核验您的身份和资质，并在平台进行必要的展示。</li>
							<li><span class="highlight">3.库存信息：</span>您在使用平台服务时，主动发布的<span class="highlight">滞纳库存、二手库存信息</span>（包括产品型号、规格、数量、描述、图片等）是我们服务的核心内容。您应确保您拥有发布这些信息的合法权利并保证其真实性。</li>
							<li><span class="highlight">4.沟通信息：</span>当您通过平台与其他用户沟通、咨询客服或向我们反馈时，我们会收集您提供的<span class="highlight">联系方式和沟通内容。</span></li>
						</ol>
						<p><span class="highlight">我们在您使用服务过程中自动收集的信息：</span></p>
						<ol class="policy-list" start="1">
							<li><span class="highlight">1.设备信息：</span>我们会根据您在软件安装及使用中的具体操作，接收并记录您所使用的<span class="highlight">设备型号、操作系统版本、唯一设备标识符（如IMEI、Android ID）、MAC地址、IP地址</span>等软硬件特征信息。</li>
							<li><span class="highlight">2.服务日志信息：</span>当您使用我们的服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括<span class="highlight">浏览记录、搜索查询、点击查看、发布信息、交易沟通记录，以及IP地址、浏览器类型、电信运营商、访问日期和时间。</span></li>
							<li><span class="highlight">3.位置信息：</span>在获得您授权的前提下，我们可能会通过IP地址或GPS等方式收集您的大致<span class="highlight">地理位置信息，</span>用于为您展示所在地域相关的库存信息或防范欺诈风险。</li>
						</ol>
						<p><span class="highlight">我们从第三方获取的信息：</span></p>
						<p>在符合法律法规的前提下，我们可能会从<span class="highlight">合作伙伴</span>（如第三方认证机构）处获取一些您的信息，并将其与我们已有的您的信息进行结合，以更好地为您提供服务。</p>
						<h3 class="subchapter-title">（二）我们如何使用您的信息</h3>
						<p>我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下目的：</p>
						<p><span class="highlight">向您提供服务：</span>用于用户注册、身份认证、库存信息发布与展示、交易撮合与沟通、客户服务等。</p>
						<p><span class="highlight">保障交易安全：</span>用于身份验证、安全防范、诈骗监测、预防或禁止非法活动、降低信用风险。</p>
						<p><span class="highlight">优化及改进服务：</span>通过分析用户使用习惯、进行数据统计和研究，以改进我们的产品、服务及用户体验。</p>
						<p><span class="highlight">向您发送信息：</span>向您发送与服务有关的通知、公告（如交易状态更新、政策变更）或您可能感兴趣的营销活动信息（您可选择退订）。</p>
						<p><span class="highlight">其他征得您同意的用途。</span></p>
						<!-- 二、我们如何使用Cookie和同类技术 -->
						<h2 class="chapter-title">二、我们如何使用Cookie和同类技术</h2>
						<p>为确保网站正常运转、为您获得更轻松的访问体验，我们会在您的计算机或移动设备上存储名为 <span class="highlight">Cookie </span>的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助Cookie，我们能够存储<span class="highlight">您的偏好、浏览历史，</span>从而帮助您省去重复输入注册信息的步骤，或帮助判断您的登录状态110。</p>
						<p>您有权根据自己的偏好管理或删除Cookie。您可以通过修改浏览器设置的方式拒绝Cookie，但这可能会影响您安全访问脱手网或不能使用我们依赖于Cookie提供的服务。</p>
						<!-- 三、我们如何共享、转让、公开披露您的信息 -->
						<h2 class="chapter-title">三、我们如何共享、转让、公开披露您的信息</h2>
						<h3 class="subchapter-title">（一）共享</h3>
						<p>我们不会与脱手网服务提供者以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
						<p><span class="highlight">在获取明确同意的情况下共享：</span>获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
						<p><span class="highlight">向我们的关联方共享：</span>您的个人信息可能会与脱手网的关联公司共享，但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。</p>
						<p><span class="highlight">向授权合作伙伴共享：</span>我们可能会向为我们提供服务的<span class="highlight">供应商、承包商、代理机构</span>（例如提供支付处理、数据存储、IT基础设施、客户服务、数据分析、审计服务的机构）共享您的信息。这些合作伙伴<span class="highlight">只能接触到其提供服务所必需的信息，</span>且必须按照我们的指示、本政策以及其他任何相关的保密和安全措施来处理个人信息1。</p>
						<p><span class="highlight">基于法律或合法依据的共享：</span></p>
						<ul class="policy-list">
							<li>遵守适用的法律法规、法院指令或其他法律程序。</li>
							<li>响应政府主管部门、司法机关的强制性要求或法律程序。</li>
							<li>在法律法规允许的范围内，为保护脱手网、我们的用户或社会公众的权益、财产或安全免遭损害而有必要提供。</li>
						</ul>
						<h3 class="subchapter-title">（二）转让</h3>
						<p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
						<ul class="policy-list">
							<li>在获取明确同意的情况下转让；</li>
							<li>随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将确保信息在转移时的机密性，并要求新的持有您个人信息的公司、组织继续受此隐私政策的约束。</li>
						</ul>
						<h3 class="subchapter-title">（三）公开披露</h3>
						<p>我们<span class="highlight">仅在以下情况下，</span>且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息：</p>
						<ul class="policy-list">
							<li>获得您明确同意后；</li>
							<li>基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下。</li>
						</ul>
						<!-- 四、我们如何存储和保护您的信息 -->
						<h2 class="chapter-title">四、我们如何存储和保护您的信息</h2>
						<h3 class="subchapter-title">（一）信息存储</h3>
						<p><span class="highlight">存储地点：</span>我们在中华人民共和国境内运营中收集和产生的个人信息，<span class="highlight">将存储在中华人民共和国境内。</span>如需跨境传输，我们会单独征得您的授权同意，并确保达到法律法规要求的保护标准。</p>
						<p><span class="highlight">存储期限：</span>我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求（例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年）。在超出保留期间后，我们会根据适用法律的要求<span class="highlight">删除您的个人信息，或对其进行匿名化处理。</span></p>
						<h3 class="subchapter-title">（二）信息保护</h3>
						<p>我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止其遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。</p>
						<p>我们采用<span class="highlight">加密技术</span>（如SSL）对部分重要数据进行加密保护。</p>
						<p>我们对员工进行信息安全培训，并<span class="highlight">严格限制访问信息的人员范围，</span>要求他们遵守保密义务。</p>
						<p>我们建立了<span class="highlight">数据安全分级管理制度</span>和<span class="highlight">数据安全应急响应计划，</span>以应对可能的信息安全事件。</p>
						<p><span class="highlight">但请您理解，</span>由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
						<!-- 五、您的权利 -->
						<h2 class="chapter-title">五、您的权利</h2>
						<p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
						<p><span class="highlight">访问和更正您的个人信息：</span>您有权访问您的账户信息和发布内容，并可以随时更正或更新它们（法律规定的例外情况除外）。</p>
						<p>删除您的个人信息：在以下情况下，您可以向我们提出删除个人信息的请求：</p>
						<ul class="policy-list">
							<li>处理目的已实现、无法实现或者为实现处理目的不再必要；</li>
							<li>我们停止提供产品或者服务，或者保存期限已届满；</li>
							<li>您撤回了同意；</li>
							<li>我们违反法律、行政法规或者违反约定处理个人信息；</li>
							<li>法律、行政法规规定的其他情形。</li>
						</ul>
						<p><span class="highlight">改变您授权同意的范围：</span>您可以通过删除信息、关闭设备功能、在客户端设置中更改授权范围等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。<span class="highlight">但您撤回同意或授权后，我们可能无法继续为您提供撤回同意或授权所对应的服务。</span></p>
						<p><span class="highlight">注销您的账户：</span>您可以通过客户服务或平台提供的在线流程申请注销您的脱手网账户。在注销账户后，我们将停止为您提供产品或服务，并依据您的要求，<span class="highlight">删除您的个人信息或进行匿名化处理，</span>法律法规另有规定的除外。</p>
						<p><span class="highlight">响应您的上述请求：</span>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在<span class="highlight">15天内</span>作出答复。</p>
						<!-- 六、我们如何处理儿童的个人信息 -->
						<h2 class="chapter-title">六、我们如何处理儿童的个人信息</h2>
						<p>我们的产品、网站和服务<span class="highlight">主要面向企业用户和成年人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。</span></p>
						<p>对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</p>
						<!-- 七、本政策如何更新 -->
						<h2 class="chapter-title">七、本政策如何更新</h2>
						<p>根据业务发展和法律法规的变化，我们可能会适时更新本政策。更新后的政策将在脱手网平台上发布，并<span class="highlight">自发布之日起生效。</span></p>
						<p>对于重大变更（例如业务功能、使用目的、个人信息处理方式等发生重大变化），我们将通过<span class="highlight">网站公告、推送通知、短信提醒等显著方式</span>通知您。请您定期查阅本政策以了解最新内容。</p>
						<!-- 八、如何联系我们 -->
						<h2 class="chapter-title">八、如何联系我们</h2>
						<p>如果您对本隐私政策或个人信息保护相关事宜有任何疑问、意见或建议，您可以通过以下方式与我们联系：</p>
						<ul class="policy-list">
							<li><span class="highlight">客服电话：</span>400-800-3135</li>
							<li><span class="highlight">在线客服：</span>通过脱手网APP或网站联系在线客服</li>
							<li><span class="highlight">电子邮件：</span>2558065390@qq.com</li>
							<li><span class="highlight">邮寄地址：</span>[江苏省南京市玄武区钟灵街60号紫金阁商务大厦556室]</li>
						</ul>
						<p>一般情况下，<span class="highlight">我们将在收到您的问题后十五天内予以回复。</span></p>
						<p>如果您对我们的回复不满意，特别是认为我们的个人信息处理行为损害了您的合法权益，您还可以向<span class="highlight">网信、电信、公安及工商等监管部门进行投诉或举报</span></p>
						<p>
							<span class="highlight">再次感谢您对脱手网的信任！</span>
						</p>
					</div>
				</el-col>
			</el-row>
		</div>
		<el-row class="logo_m">
			<el-col :span="24">
				<div>
					CopyRight © 脱手网 2018 苏ICP备18008659号
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import HeadIndex from '../public/HeadIndex';
export default {
	name: 'product',
	components: {
		HeadIndex
	},
	data() {

		return {

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {

		this.tableHeight_fun();
	},
	watch: {

	},
	methods: {
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 55
			})
		},
	}
}
</script>
<style lang="less" scoped>
/* 基础样式：保障阅读清晰性与适配性 */
body {
	font-family: "Microsoft YaHei", Arial, sans-serif;
	line-height: 1.8;
	color: #333;
	padding: 20px;
	max-width: 1000px;
	margin: 0 auto;
	background-color: #f9f9f9;
}

.policy-wrap {
	background-color: #fff;
	padding: 30px;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.policy-title {
	font-size: 24px;
	color: #222;
	text-align: center;
	margin: 0 0 20px;
	padding-bottom: 15px;
	border-bottom: 1px solid #eee;
}

.policy-date {
	text-align: center;
	color: #666;
	font-size: 14px;
	margin: 0 0 30px;
	font-weight: 700;
}

.policy-intro {
	margin: 0 0 30px;
	text-align: justify;
}

/* 重点条款样式：加粗+下划线 */
.highlight {
	font-weight: 700;
}

/* 章节标题样式 */
.chapter-title {
	font-size: 30px;
	color: #222;
	margin: 40px 0 15px;
	padding-left: 10px;
	border-left: 3px solid #2196f3;
}

/* 子章节标题样式 */
.subchapter-title {
	font-size: 22px;
	color: #333;
	margin: 25px 0 12px;
	font-weight: 600;
}

/* 列表样式 */
.policy-list {
	margin: 10px 0 10px 20px;
	padding-left: 10px;
}

.policy-list li {
	margin: 8px 0;
	text-align: justify;
}


:deep(.el-input-group__append) {
	background: #ff8a5c;
}
</style>